import { injectable, inject } from 'inversify';
import { ok, err } from '@/app/tracking/tracking-api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { StudentInfoDataStore, StudentInfoErrorCode } from '../common/student-info-data-store';

@injectable()
export class Scorm2004StudentInfoDataStore implements StudentInfoDataStore {

  constructor(
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }

  public async get() {
    const learnerIdResult = await this.tryGetValue('cmi.learner_id');
    if (!learnerIdResult.success) { return learnerIdResult }
    const learnerNameResult = await this.tryGetValue('cmi.learner_name');
    if (!learnerNameResult.success) { return learnerNameResult }

    return ok({
      id: learnerIdResult.value,
      fullName: learnerNameResult.value
    })
  }

  private async tryGetValue(key: string) {
    const result = await this.client.getValue(key);
    if (!result.success) {
      return err({
        code: 'query-error' as StudentInfoErrorCode,
        details: result.error
      });
    }

    return result
  }
}
